module.exports = __webpack_public_path__ + "img/planehead.2ec4fb3c.svg";